import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { User } from '../../_models';
import { UserService, AuthenticationService, NotificationService, EnvService } from '../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({ templateUrl: 'home.component.html' })
export class HomeComponent implements OnInit {
    currentUser: User;
    roleList = {};
    greeting = "Hi Welcome";
    day = "";

    constructor(private authSvc: AuthenticationService,
      private envService: EnvService){
      this.currentUser = this.authSvc.currentUserValue;
    }

    ngOnInit(): void {
        this.loadRoles();
        this.loadGreeting();
        var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        this.day = new Date().toLocaleString("en-US", options);
    }

    private loadRoles() {
      this.envService.getRoles().pipe(first()).subscribe(data => {
        this.roleList = data.data;
      })
    }

    private loadGreeting(){
      let date = new Date();
      let currentHour = date.getHours();
      console.log(currentHour)

      if(currentHour < 12){
        this.greeting = "Good Morning";
      }else if(currentHour < 18){
        this.greeting = "Good Afternoon";
      }else{
        this.greeting = "Good Evening";
      }
    }

}
